import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { useCurrentUserId } from '#src/app/shared/hooks/session';

import { prefetchPetitionActionsPageDataFromApi, usePetitionActionsPageDataFromApi } from './pageData';

export type PetitionActionsPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof usePetitionActionsPageDataFromApi>[0];
}>;

export type PetitionActionsPageCombinedState = ReturnType<typeof usePetitionActionsPageDataFromApi>;

export function usePageContext(
	slug: string,
	prefetchedData?: PetitionActionsPagePrefetchedContext,
): PetitionActionsPageCombinedState {
	const userId = useCurrentUserId();

	return usePetitionActionsPageDataFromApi(prefetchedData?.pageData, slug, userId);
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<PetitionActionsPagePrefetchedContext> {
	const userId = context.session?.user?.id;

	const pageData = await prefetchPetitionActionsPageDataFromApi(context, slug, userId);

	return { pageData };
}

export type PetitionActionsPagePrefetchedDataProps = PrefetchedDataProps<PetitionActionsPagePrefetchedContext>;
